<template>
  <div class="page-wrapper"> 
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <div class="cg-mod-title">基础信息</div>
        <div class="form-top-btns">
          <button class="cg-btn" @click="toEditStock">修改库存</button>
        </div>
        <div class="cg-form-mod">
            <el-form-item label="所属品牌：" required>
              {{detail.brand}}
            </el-form-item>
            <el-form-item label="商品名称：" prop="productName">
              <el-input size="mini" class="w48" maxlength="50" v-model="ruleForm.productName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="商品款号：" required>
                {{detail.styleNumber}}
            </el-form-item>
            <el-form-item label="吊牌价：" prop="itemOriginalPrice">
              <el-input size="mini" class="w26" style="width: 160px" v-model="ruleForm.itemOriginalPrice" placeholder="请输入吊牌价"></el-input>
              <span class="unit">元</span>
            </el-form-item>
            <el-form-item label="销售价格：" prop="sellingPrice">
              <el-input size="mini" style="width: 160px" v-model="ruleForm.sellingPrice" placeholder="请输入销售价格"></el-input> 
              <span class="unit">元</span>
              <span class="result-text">结算价格：{{settlePrice}} 元</span>
            </el-form-item>
            <el-form-item label="" prop="rate">
              <div class="tip-text" style="height: 30px;">
                分佣比例为“销售商 : 供应商={{dealerRate}}% :
                <el-input size="mini" class="w26" style="width: 80px" v-model="ruleForm.rate" placeholder="请输入"></el-input>
                %”，平台服务费为您分佣后获得收益的{{seviceFeeRateShow}}，如 单件所收服务费=单价x分佣比例x{{seviceFeeRateShow}}。
              </div>
            </el-form-item>
            <el-form-item label="商品类目：">
              <template v-if="!cateEdit">
                {{detail.productCategory}} <el-button type="button" size="small" style="margin-left: 16px" @click="cateEdit = true">修改</el-button>
              </template>
              <template v-else>
                <el-col :span="5">
                  <el-form-item prop="productCategory_cate1">
                    <el-select size="mini" v-model="ruleForm.productCategory_cate1" style="width: 94%"
                      value-key="category_id" placeholder="请选择类目" @change="selectCate(1)">
                      <el-option :label="item.category_name" :value="item" v-for="item in cateList1" :key="item.category_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="productCategory_cate2">
                    <el-select size="mini" v-model="ruleForm.productCategory_cate2" style="width: 94%"
                      value-key="category_id" placeholder="请选择类目" @change="selectCate(2)">
                      <el-option :label="item.category_name" :value="item" v-for="item in cateList2" :key="item.category_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="productCategory_cate3">
                    <el-select size="mini" v-model="ruleForm.productCategory_cate3" style="width: 94%"
                      value-key="category_id" placeholder="请选择类目">
                      <el-option :label="item.category_name" :value="item" v-for="item in cateList3" :key="item.category_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-button type="button" size="small" @click="cateEdit = false">取消修改</el-button>
                </el-col>
              </template>
            </el-form-item>
        </div>
        
        <div class="cg-mod-title">面辅料信息</div>
        <div class="cg-form-mod">
            <el-form-item label="主面料名称：">
              <el-input size="mini" class="w26" v-model="ruleForm.fabricName" placeholder="请输入主面料名称"></el-input>
            </el-form-item>
            <el-form-item label="主面料成分：">
              <el-radio-group v-model="ruleForm.fabricIngredient_type">
                <el-radio :label="1">
                  <span style="margin-right: 10px;">自填</span>
                  <el-input size="mini" class="w14" v-model="ruleForm.fabricIngredient_custom" placeholder="请输入主面料成分"></el-input>
                </el-radio>
                <el-radio :label="2">
                  <span style="margin-right: 10px;">选择面料</span>
                  <el-select size="mini" style="margin-right: 16px; width: 140px" v-model="ruleForm.fabricIngredient_seclet" placeholder="请选择">
                    <el-option :label="item.dataName" :value="item.dataName" v-for="(item, index) in fabricList" :key="index"></el-option>
                  </el-select>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="填充物：">
              <el-input size="mini" class="w26" v-model="ruleForm.fabricStuffing" placeholder="请输入主面料成分"></el-input>
            </el-form-item>
        </div>
        <div class="cg-mod-title">商品图片</div>
        <div class="cg-form-mod">
            <el-form-item label="主图：" prop="imageUrl">
              <el-upload
                class="cg-img-uploader"
                :action="uploadFileApi"
                name="files"
                :data="uploadData"
                :show-file-list="false"
                :on-success="handleImgSuccess"
                :before-upload="beforeImgUpload"
                accept="image/*">
                <el-image
                  v-if="ruleForm.imageUrl"
                  class="cg-img"
                  :src="ruleForm.imageUrl"
                  fit="cover"
                ></el-image>
                <!-- <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="cg-img"> -->
                <i v-else class="el-icon-plus cg-img-uploader-icon"></i>
              </el-upload>
            </el-form-item>
        </div>
        <div class="cg-mod-title">商品详情</div>
        <div class="cg-form-mod">
            <editor :user-id="$route.query.userId" v-model="ruleForm.editorContent" :dataLoaded="editorDataLoaded"/>
        </div>
    </el-form>
    <div class="bottom-btns-wrap">
        <el-button type="primary" @click="submitForm">确认编辑商品</el-button>
    </div>
    <!-- <div class="bottom-btns">
      <button class="cg-btn red">确认编辑商品</button>
    </div> -->
  </div>
</template>

<script>
import editor from "../../components/Editor"
import { ajaxPost, api } from '@/common/request.js'
import { settlePrice, accSub, accDiv, cTrim, accMul } from '@/common/tool.js'
import { validatePrice } from "@/common/validate.js"

export default {
  components: {
    editor
  },
  computed: {
    settlePrice: function () {
      return settlePrice(this.ruleForm.sellingPrice, this.ruleForm.rate)
    },
    seviceFeeRateShow: function() {
      console.log(this.$sysConfig)
      return this.$sysConfig.globalServiceChargePercent
    },
    dealerRate: function () {
      if (!isNaN(Number(this.ruleForm.rate)) && Number(this.ruleForm.rate) >= 0 && Number(this.ruleForm.rate) <= 100) {
        return accSub(100, Number(this.ruleForm.rate))
      }
      return '--'
    }
  },
  data() {
    var validatePriceFn = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写价格'));
      } else if (!validatePrice(value)) {
        callback(new Error('价格格式不正确'));
      } else {
        callback();
      }
    }
    var validateRate =  (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写比例'))
      } else if (!validatePrice(value)) {
        callback(new Error('比例格式不正确'))
      } else if (value < 0 || value > 100) {
        callback(new Error('比例必须填0-100之间的数，最多两位小数'))
      } else {
        callback();
      }
    }
    var validateProductName = (rule, value, callback) => {
      if (cTrim(value) === "") {
        callback(new Error("请填写商品名称"));
      } else {
        callback();
      }
    };
    return {
      // 类目
      cateList1: [], 
      cateList2: [],
      cateList3: [],
      cateEdit: false,

      // 面料列表
      fabricList: [], 

      // 上传图片api
      uploadFileApi: '',
      uploadData: {
        imageType: 12101,
        imageUserId: ''
      },

      // 商品详情
      detail: {},

      // 富文本编辑器是否已获取到数据
      editorDataLoaded: false,

      ruleForm: {
        brand: "",
        productName: "",
        styleNumber: "",
        itemOriginalPrice: "",
        sellingPrice: "",
        rate: 60,
        productCategory_cate1: '',
        productCategory_cate2: '',
        productCategory_cate3: '',

        imageUrl: '',
        imgItem: '',

        editorContent: '',

        fabricName: '',
        fabricIngredient_type: 1, // 1 - 自填  2 - 选择
        fabricIngredient_custom: '',
        fabricIngredient_seclet: '',
        fabricStuffing: '',
      },
      rules: {
        brand: [
          { required: true, message: "请输入商品品牌", trigger: "change" }
        ],
        productName: [
          { required: true, message: "请输入商品名称", trigger: "change" },
          { validator: validateProductName, trigger: 'blur'}
        ],
        styleNumber: [
          { required: true, message: "请输入商品款号", trigger: "change" }
        ],
        itemOriginalPrice: [
          { required: true, message: "请输入吊牌价", trigger: "change" },
          { validator: validatePriceFn, trigger: 'change' }
        ],
        rate: [
          { required: true, message: "请输入供应商的比例", trigger: "change" },
          { validator: validateRate, trigger: 'change' }
        ],
        sellingPrice: [
          { required: true, message: "请输入价格", trigger: "change" },
          { validator: validatePriceFn, trigger: 'change' }
        ],
        // productCategory_cate1: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        // productCategory_cate2: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        // productCategory_cate3: [
        //   { required: true, message: "请选择类目", trigger: "change" }
        // ],
        imageUrl: [
          { required: true, message: "请上传商品图片", trigger: "change" }
        ]
      }
    };
  },
  watch:{
    
  },
  created() {
    this.uploadFileApi = api.baseUrl + '/file/uploadfilebatch'
    this.uploadData.imageUserId = this.$route.query.userId
    this.categoryInfo(1, 0)
    this.getDatasource()
    this.getMallItemInfo()
  },
  methods: {
    // 获取商品数据
    getMallItemInfo() {
      ajaxPost('/commodity/getMallItemInfo', {
        itemId: this.$route.query.id
      }).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
          let detail = res.data[0]
          this.detail = detail 
          this.ruleForm.brand = detail.brand
          this.ruleForm.productName = detail.itemName
          this.ruleForm.styleNumber =  detail.styleNumber
          this.ruleForm.itemOriginalPrice = detail.originPrice
          this.ruleForm.sellingPrice = detail.price
          let rate = detail.item_fee_splitting.split(',')[1]
          this.ruleForm.rate = rate ? accMul(rate, 100) : '60'

          this.ruleForm.imageUrl = api.imgPrev+ detail.mallItemFileUrl
          this.ruleForm.imgItem = {
            imageFiles: detail.mallItemFileUrl,
            imgId: detail.mallItemImageId
          }

          try {
            let fab= JSON.parse(detail.fabricAndAccessoryStr)
            this.ruleForm.fabricName = fab.fabricName || ''
            this.ruleForm.fabricIngredient_type = fab.fabricIngredient_type || 1 // 1 - 自填  2 - 选择
            this.ruleForm.fabricIngredient_custom = fab.fabricIngredient_custom || ''
            this.ruleForm.fabricIngredient_seclet = fab.fabricIngredient_seclet || ''
            this.ruleForm.fabricStuffing = fab.fabricStuffing || ''
          } catch (error) {
            console.log(error)
          }

          this.ruleForm.editorContent = detail.productContent
          this.editorDataLoaded = true
          
        } else {
          this.$message.error(res.errorMsg || '获取详情数据异常')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取类目列表
    categoryInfo(type, id) {
      ajaxPost('/yijiajiaDataCategory/categoryInfo', {parentId: id}).then(res => {
        if (res.errorCode == 200) {
          if (type == 1) {
            this.cateList1 = res.data
            
          }
          if (type == 2) {
            this.cateList2 = res.data
            this.ruleForm.productCategory_cate2 = ''
            this.ruleForm.productCategory_cate3 = ''
          }
          if (type == 3) {
            this.cateList3 = res.data
            this.ruleForm.productCategory_cate3 = ''
          }
        }
      })
    },
    // 选择品类
    selectCate(type) {
      if(type == 1) {
        console.log(this.ruleForm.productCategory_cate1)
        this.categoryInfo(2, this.ruleForm.productCategory_cate1.category_id)
      }
      if (type == 2) {
        this.categoryInfo(3, this.ruleForm.productCategory_cate2.category_id)
      }
    },
    // 获取尺码数据
    getDatasource() {
      ajaxPost('/yijiajiaDataCategory/getDatasource', {types: '10237'}).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
          this.fabricList = res.data.mainComponentFabric.list
        }
      })
    },
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {

          let productCategory = ''
          if (!this.cateEdit) {
            productCategory = this.detail.productCategory || ''
          } else {
            if (this.ruleForm.productCategory_cate1.category_name) {
              productCategory += this.ruleForm.productCategory_cate1.category_name
            }
            if (this.ruleForm.productCategory_cate2.category_name) {
              productCategory += '-' + this.ruleForm.productCategory_cate2.category_name
            }
            if (this.ruleForm.productCategory_cate3.category_name) {
              productCategory += '-' + this.ruleForm.productCategory_cate3.category_name
            }       
          }
          
          let fabricAndAccessory = {}
          fabricAndAccessory['fabricName'] = this.ruleForm.fabricName
          fabricAndAccessory['fabricStuffing'] = this.ruleForm.fabricStuffing
          fabricAndAccessory['fabricIngredient_type'] = this.ruleForm.fabricIngredient_type
          if (this.ruleForm.fabricIngredient_type == 1) {
            fabricAndAccessory['fabricIngredient_custom'] = this.ruleForm.fabricIngredient_custom
            fabricAndAccessory['fabricIngredient_seclet'] = ''
          } else {
            fabricAndAccessory['fabricIngredient_custom'] = ''
            fabricAndAccessory['fabricIngredient_seclet'] = this.ruleForm.fabricIngredient_seclet
          }
          let fabricAndAccessoryStr = JSON.stringify(fabricAndAccessory)

          let imgJsonArr = []
          if (this.ruleForm.imgItem) {
            imgJsonArr.push(this.ruleForm.imgItem)
          }
          let imgJson = JSON.stringify(imgJsonArr)

          let supplierRate = (this.ruleForm.rate / 100).toFixed(2)
          let dealerRate = (this.dealerRate / 100).toFixed(2)
          let itemFeeSplitting = dealerRate + ',' + supplierRate

          let form = {
            userId: this.$route.query.userId,
            itemId: this.detail.item_id,
            productName: cTrim(this.ruleForm.productName),
            sellingPrice: this.ruleForm.sellingPrice,
            itemOriginalPrice: this.ruleForm.itemOriginalPrice,
            itemFeeSplitting: itemFeeSplitting,
            productCategory: productCategory,
            fabricAndAccessoryStr: fabricAndAccessoryStr,
            imgJson: imgJson,
            productContent: this.ruleForm.editorContent
          }
          console.log(form);
          ajaxPost('/commodity/editMallItemInfo', form).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
              this.$message.success('编辑商品成功')
              this.$router.go(-1)
            } else {
              this.$message.error(res.errorMsg || '编辑商品失败')
            }
          }).catch(err => {
            console.log(err)
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleImgSuccess(res, file) {
      console.log(res, file)
      if (res.errorCode == 200) {
        this.ruleForm.imgItem = res.data
        this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
        this.$refs['ruleForm'].clearValidate('imageUrl')
      }
    },
    beforeImgUpload(file) {
      console.log(file)
      const isImg = /^image\/*/.test(file.type)
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('请上传图片格式的文件!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isImg && isLt5M;
    },
    toEditStock() {
      this.$router.push('/stock/edit?id=' + this.$route.query.id + '&userId=' + this.$route.query.userId)
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 0 24px 40px;

  .form-top-btns {
    width: 980px;
    text-align: right;
    .cg-btn {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: .1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 7px 24px;
      font-size: 12px;
    
      &:active {
        opacity: 0.8;
      }
    }
  }
  .size-type-wrap {
    margin-top: 8px;
    
  }
  .size-list-wrap {
    margin-top: 16px;
    padding: 24px;
    width: 680px;
    box-sizing: border-box;
    background: rgba(0,0,0,0.02);
    .check-box {margin-bottom: 16px;}
  }
  .btn-wrap {
    margin-top: 24px;
  }
  .color-group {
    margin-top: 16px;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .result-text.w {
    display: inline-block;
    width: 160px;
  }
  .color-btn {
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &.btn-expand {
      margin-left: 128px;
    }
     &.btn-close {
      margin-left: 24px;
    }
  }
  
  .color-size-number {
    padding: 10px 180px 10px 24px;
    width: 680px;
    box-sizing: border-box;
    background: rgba(0,0,0,0.02);
    .line {
      height: 50px;
      line-height: 50px;
    }
    .lab {
      float: left;
    }
    .val {
      float: right;
      text-align: center;
      width: 140px;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bottom-btns {
  position: fixed; bottom: 0; right: 0; left: 180px;
  height: 64px; text-align: right;
  background: #fff;
  box-shadow:0px -3px 6px -4px rgba(0,0,0,0.12),0px -6px 16px 0px rgba(0,0,0,0.08);
  line-height: 64px;
  z-index: 10001;
  .cg-btn {
    margin-right: 32px;
  }
}

.bottom-btns-wrap {
  width: 980px;
  padding: 40px 0;
  text-align: center;
}


</style>


// WEBPACK FOOTER //
// src/pages/goods/edit.vue